import React, { memo } from 'react';
import { Button, Space } from 'antd';
import { useBundle } from '@amzn/react-arb-tools';
import { safeGetMessage } from '@xbcb/ui-utils';
import { ClassificationResult } from './types';
import {
  StyledHtsAlert,
  RecommendationMessageWrapper,
  RecommendationRow,
} from './styles';
import { ReasoningSection } from './ReasoningSection';

export interface HtsRecommendationResultProps {
  result: ClassificationResult;
  onAccept: () => void;
  onDecline: () => void;
}

export const HtsRecommendationResult: React.FC<
  HtsRecommendationResultProps
> = ({ result, onAccept, onDecline }) => {
  const [bundle] = useBundle('components.HtsClassification');

  return (
    <StyledHtsAlert
      type="info"
      showIcon
      message={
        <RecommendationMessageWrapper>
          <RecommendationRow>
            <span>
              {safeGetMessage(bundle, 'hts_ai_recommendation_message')}{' '}
              <strong>{result.tariffCode}</strong>.{' '}
              {safeGetMessage(bundle, 'hts_verify_with_seller')}
            </span>
            <Space direction="vertical" size="small">
              <Button size="small" onClick={onAccept}>
                {safeGetMessage(bundle, 'hts_accept_recommendation')}
              </Button>
              <Button size="small" onClick={onDecline}>
                {safeGetMessage(bundle, 'hts_decline_recommendation')}
              </Button>
            </Space>
          </RecommendationRow>
          {result.reasoningTrace?.length ? (
            <ReasoningSection reasoningTrace={result.reasoningTrace} />
          ) : null}
        </RecommendationMessageWrapper>
      }
    />
  );
};

export default memo(HtsRecommendationResult);
